export const getTemplateData = (t)=>{

    /*
        q = oqg
        i = qci
        a = qai
        c = qgc
    */

    return {
        q:{
            pdf:{
                company: 'Enterprise Inc.',
                pdftitle: t('pdf.title'),
                directly_show_pdf: "",
                primaryColor: "#57C4D9",
                SecondaryColor: "#FF9865",
                description: t('pdf.description'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                button: t('pdf.button'),
                pdf: "",
                pdfThumbnail:'',
                website: "#",
                defImg: "/pdf.jpg"
            },
            links:{
                list_title: 'Jenny Leslie',
                list_description: t('links.about'),
                font_text: "GT Walsheim Pro",
                font_title: "GT Walsheim Pro",
                linkTextColor: "#FFF",
                linkColor: "#37C1B4",
                primaryColor: "#37C1B4",
                companyLogo: "/images/oqg/avatar2.webp",
                screen: false,
                linkList: [
                    {
                        name: t('links.link.About1'),
                        image: "/images/ListOfLinks/makeup.png",
                        link: ""
                    },
                    {
                        name: 'Instagram ' +  t('links.link.About2'),
                        image: "/images/ListOfLinks/instagram.png",
                        link: ""
                    },
                    {
                        name: 'TikTok ' +  t('links.link.About3'),
                        image: "/images/ListOfLinks/tiktok.png",
                        link: ""
                    },
                    {
                        name: t('links.link.About4'),
                        image: "/images/ListOfLinks/youtube.png",
                        link: ""
                    },
                    {
                        name: t('links.link.About5'),
                        image: "/images/ListOfLinks/demo.png",
                        link: ""
                    }
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'X',
                        url: "/images/social/twitter.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'TikTok',
                        url: "/images/ListOfLinks/tiktok.png"
                    }
                ]
            },
            vcard:{
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                vcard_profession: t('vcard.profession'),
                primaryColor: "#093A32",
                SecondaryColor: "#093A32",
                vcard_first_name: 'John Carlson',
                vcard_last_name: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.google'),
                        url: "/images/social/google.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.instagram'),
                        url: "/images/social/instagram.webp"
                    }
                ],
                vcard_website: [
                    {
                        title: t('vcard.website'),
                        website: "john-carlson.com"
                    }
                ],
                vcard_phone: [
                    {
                        label: "",
                        type: "other",
                        number: "555-100-1000"
                    }
                ],
                vcard_email: [
                    {
                        title: "",
                        email: "John.Carlson@gmail.com"
                    }
                ],
                vcard_note: t('vcard.summary'),
                vcard_company: t('vcard.company_name'),
                vcard_social_label: [],
                vcard_social_value: [],
                images: "/images/oqg/avatar.webp",
                offer_street: t('vcard.location_text'),
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                vcard_add_contact_at_top: 'falseprev',
                street_number: true
            },
            business:{
                contactMobiles: [
                    {
                        title: "",
                        number: "555-100-1000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "Boulangerie@gmail.com"
                    }
                ],
                contactWebsite:[
                    {title:'',website:'www.boulangerie.com'}
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.google'),
                        url: "/images/social/google.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'TikTok',
                        url: "/images/ListOfLinks/tiktok.png"
                    }
                ],
                aboutCompany: t('business.about_company_text'),
                weekDays: {
                    Monday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Tuesday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Wednesday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Thursday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Friday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Saturday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Sunday: [
                        {
                            "from": "10:00",
                            "to": "05:00"
                        }
                    ]
                },
                primaryColor: "#1A97F0",
                SecondaryColor: "#0079FF",
                companyLogo: "/images/oqg/business.webp",
                company: t('business.company'),
                companyTitle: t('business.title'),
                companySubtitle: t('business.subtitle'),
                screen: false,
                contactName: 'Boulangerie Pâtissier',
                businessButtons: t('business.button'),
                businessButtonUrls: "#",
                businessButtonsCreated: "0",
                cardContainer: false,
                ship_address: "",
                offer_street: t('business.location_1'),
                offer_number: "",
                offer_postalcode: "",
                offer_city: t('business.location_2'),
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    // "ficon9",
                    "ficon10",
                    "ficon11",
                    "ficon12"
                ],
                street_number: true
            },
            images:{
                primaryColor: "#28C254",
                image_title: t('images.headerTitle'),
                image_description: t('images.headerDescription'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                website: "www.mypictures.com",
                images: [
                    "/images/oqg/01.webp",
                    "/images/oqg/02.webp"
                ],
                buttons: [
                    {
                        text: t('images.viewMoreButton'),
                        url: "#"
                    }
                ],
                horizontal: true
            },
            video:{
                videos: [],
                direct_video: false,
                Highlight: false,
                Autoplay: false,
                primaryColor: "#AEE301",
                companyName: "Emily’s Kitchen",
                videoTitle: t('video.title'),
                videoDescription: t('video.description'),
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                button_text: t('video.view_more'),
                button_url: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'TikTok',
                        url: "/images/ListOfLinks/tiktok.png"
                    }
                ],
            },
            app:{
                screen: false,
                SecondaryColor: "#CA182B",
                primaryColor: "#CA182B",
                app_title: 'Nourish',
                app_description: t('app.description'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                app_website: "www.nourish.com",
                app_company: t('app.base'),
                google: "#",
                apple: "#",
                amazon: "#",
                images: [],
                companyLogo: "/images/oqg/nourish.webp",
            },
            coupon:{
                screen: false,
                ship_address: "",
                company: t('coupon.company'),
                title: t('coupon.salesBadge'),
                description: t('coupon.offerDescription'),
                salesBadge: t('coupon.salesBadge'),
                buttonToSeeCode: t('coupon.offerButton'),
                couponCode: "25%%20OFF",
                validTillDate: "",
                terms: [t('coupon.termsParagraph')],
                buttonText: t('coupon.webButton'),
                buttonUrl: "#",
                primaryColor: "#C12EFE",
                SecondaryColor: "#EDED4F",
                companyLogo: "/images/oqg/sale.webp",
                offerImage: "https://t3.ftcdn.net/jpg/02/55/97/94/360_F_255979498_vewTRAL5en9T0VBNQlaDBoXHlCvJzpDl.jpg",
                offer_street: "",
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                street_number: false,
                flip: false,
                barCodeTgl: true,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro"
            },
            mp3:{
                screen: false,
                addDownloadOption: "",
                button_url: "",
                button_text: t('mp3.viewMoreButton'),
                primaryColor: "#7572FF",
                SecondaryColor: "#7572FF",
                mp3_title: 'Night Drive',
                mp3_description: t('mp3.songDescription'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                mp3_website: "#",
                mmp3: [
                    "/empty.mp3"
                ],
                images: [],
                image: "/images/oqg/mp3.webp",
                button_created: "0",
                socialLinks: [ 
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('mp3.social.spotify'),
                        url: "/images/social/spotify.svg"
                    }
                ],
            },
            menu:{
                sections: [
                    {
                        id: "1",
                        name: t('menu.section_1'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('menu.section_1_product_name'),
                                image: "/images/menu/productImages_vegetable-salad.webp",
                                translated: "Salat",
                                description: t('menu.section_1_product_desc'),
                                price: "12",
                                allergens: [
                                    "cereals",
                                    "crustaceans"
                                ]
                            }
                        ]
                    },
                    {
                        id: "8",
                        name: t('menu.section_2'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('menu.section_2_product_name'),
                                image: "/images/menu/productImages_Orange.webp",
                                translated: "Orangensaft",
                                description: t('menu.section_2_product_desc'),
                                price: "8",
                                allergens: [
                                    "peanuts",
                                    "soy"
                                ]
                            }
                        ]
                    },
                    {
                        id: "78",
                        name: t('menu.section_3'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('menu.section_3_product_name'),
                                image: "/images/menu/productImages_donuts.webp",
                                translated: "Glasierter Hefe-Donut",
                                description: t('menu.section_3_product_desc'),
                                price: "6",
                                allergens: [
                                    "milk",
                                    "fruits"
                                ]
                            }
                        ]
                    },
                    {
                        id: "139",
                        name: t('menu.section_4'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('menu.section_4_product_name'),
                                image: "/images/menu/productImages_fish.webp",
                                translated: "Gebratener Lachs mit Walnuss",
                                description: t('menu.section_4_product_desc'),
                                price: "45",
                                allergens: [
                                    "eggs",
                                    "fish"
                                ]
                            }
                        ]
                    }
                ],
                socialLinks: [
                    {
                        name: "",
                        text: "",
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: "",
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: "",
                        icon: "Google",
                        url: "/images/social/google.png"
                    },
                    {
                        name: "",
                        text: "",
                        icon: "X",
                        url: "/images/social/twitter.png"
                    },
                    {
                        name: "",
                        text: "",
                        icon: "TikTok",
                        url: "/images/ListOfLinks/tiktok.png"
                    }
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "555-100-1000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "TastyFood@gmail.com"
                    }
                ],
                activeId: "",
                // contactName: t('menu.restaurant_name'),
                contactWebsite:[
                    {title:'',website:'www.tastyfood.com'}
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                primaryColor: "#FF6228",
                companyLogo: "/images/oqg/tastyfood.webp",
                companyTitle: t('menu.restaurant_name'),
                companyDescription: t('menu.restaurant_desc'),
                screen: false,
                weekDays: {
                    Saturday: [
                        {
                            from: "10:00",
                            to: "14:00"
                        },
                        {
                            from: "17:00",
                            to: "23:00"
                        }
                    ],
                    Sunday: [
                        {
                            from: "10:00",
                            to: "17:00"
                        }
                    ],
                    Monday: [
                        {
                            from: "10:00",
                            to: "17:00"
                        }
                    ],
                    Tuesday: [
                        {
                            from: "10:00",
                            to: "17:00"
                        }
                    ],
                    Wednesday: [
                        {
                            from: "10:00",
                            to: "17:00"
                        }
                    ],
                    Thursday: [
                        {
                            from: "10:00",
                            to: "17:00"
                        }
                    ]
                },
                areAllDaysNull: true
            },
            event:{
                screen: false,
                primaryColor: "#00296B",
                title: t('event.title'),
                description: t('event.description'),
                image: "/images/images/new/event.webp",
                buttonText: t('event.view_more_btn'),
                buttonUrl: "#",
                event_startDate: "2024-02-08",
                event_startTime: t('event.start_time'),
                event_endDate: "2024-02-09",
                event_endTime: t('event.end_time'),
                event_time_zone: "Europe/London",
                event_preview: true,
                aboutEvent: t('event.about_description'),
                offer_street: "Gower Street",
                offer_number: "49",
                offer_postalcode: "",
                offer_city: "London",
                ship_address:  t('event.address'),
                offer_state: "WC1F 2FA",
                offer_country: "United Kingdom",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                offer_street_number: true,
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                    // "ficon12",
                    // "ficon13",
                    // "ficon14",
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "555-100-1000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "info@quantech.com"
                    }
                ],
                contactWebsite: [
                    {
                        title: "",
                        website: "www.quantech.com"
                    },
                ],
                contactName: t('event.contact_name'),
                websites: [
                    {
                        title: "Website",
                        website: "www.quantech.com"
                    },
                ],
                
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            facebook:{
                screen: false,
                cover: "/images/oqg/fb_cover.png",
                profileImg: "/images/oqg/fb_pic.webp",
                title: t('facebook.title'),
                description: t('facebook.description'),
                pageUrl: "#",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                hide_like:false,
                page_likes:'5.8k'
            },
            social:{
                screen: false,
                primaryColor: "#A8BDE2",
                images: [
                    "/images/oqg/social_media/1.webp",
                    "/images/oqg/social_media/2.webp",
                    "/images/oqg/social_media/3.webp",
                ],
                title: "Ariel Campbell",
                description: t('social.description'),
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "YouTube",
                        url: "/images/social/youtube.png"
                    },
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                horizontal: false
            },
            review:{
                screen: false,
                primaryColor: "#97000F",
                type: "both", //public, private or both
                publicReviewType: {
                    image: "/images/oqg/google.svg",
                    title: "Google Rating",
                },
                emailInput: true,
                phoneInput: true,
                title: "Los Angeles Bus Tour",
                image: "/images/oqg/rate.webp",
                website: "www.bustour.com",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            instagram:{
                username: t('instagram.username'),
                step: 1,
                live: true
            },
            email:{
                screen: false,
                colors: {
                    primary: "#8966A6",
                    secondary: "#000",
                },
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                basic_information: {
                    image: "/images/oqg/email-bg.png",
                    title: t('email.title'),
                    description: t('email.description'),
                },
                email_templates: [
                    {
                        title: t('email.list_1'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "message",
                    },
                    {
                        title: t('email.list_2'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "multimedia",
                    },
                ],
                contactName: t('email.contact_name'),
                contact_details: {
                    phones: [
                        { label: t('com_contact.contact_phone'), icon: "other", number: "555-100-1000" },
                    ],
                    emails: [
                        { label: t('com_contact.contact_email'), email: "info@greenlife.com" },
                    ],
                    websites: [
                        { label: t('com_contact.contact_website'), url: "www.glarchitect.com" },
                    ],
                },
            },
            whatsapp:{
                number: "+123 456 789",
                message: "",
                step: 1,
                live: true
            },
            sms:{
                sms_number: "+123 456 7890",
                sms_message: "",
                step: 1,
                live: true
            },

        },
        i:{
            pdf: {
                company: 'North American Accountants, Inc.',
                pdftitle: t('qrc_io.pdf.title'),
                directly_show_pdf: "",
                primaryColor: "#F37736",
                description:  t('qrc_io.pdf.description'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                button: t('pdf.button'),
                pdf: "",
                pdfThumbnail:'',
                website: "www.naai.com",
                defImg: "/pdf.jpg"
            },
            links:{
                list_title: 'Julia Anderson',
                list_description:  t('qrc_io.links.about'),
                font_text: "GT Walsheim Pro",
                font_title: "GT Walsheim Pro",
                primaryColor: "#104E6D",
                companyLogo: "/images/qci/links/julia.png",
                screen: false,
                linkList: [
                    {
                        name: t('qrc_io.links.link.About1'),
                        image: "/images/qci/links/julia.png",
                        link: ""
                    },
                    {
                        name: t('qrc_io.links.link.About2'),
                        image: "/images/qci/links/youtube.png",
                        link: ""
                    },
                    {
                        name: t('qrc_io.links.link.About3'),
                        image: "/images/qci/links/tiktok.png",
                        link: ""
                    },
                    {
                        name: t('qrc_io.links.link.About4'),
                        image: "/images/qci/links/fitness.png",
                        link: ""
                    },
                    {
                        name: t('qrc_io.links.link.About5'),
                        image: "/images/qci/links/fiton.png",
                        link: ""
                    }
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'WhatsApp',
                        url: "/images/social/whatsapp.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Instagram',
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Facebook',
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'x',
                        url: "/images/social/x.png"
                    },
                ]
            },
            vcard:{
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                vcard_profession: t('qrc_io.vcard.company_name'),
                primaryColor: "#467EF9",
                vcard_first_name: 'David Elson',
                vcard_last_name: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin-full.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.google'),
                        url: "/images/social/google-transparent.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.instagram'),
                        url: "/images/social/instagram.webp"
                    }
                ],
                vcard_website: [
                    {
                        title: t('vcard.website'),
                        website: "www.creativedesign.com"
                    }
                ],
                vcard_phone: [
                    {
                        label: "",
                        type: "other",
                        number: "(123) 555-2000"
                    }
                ],
                vcard_email: [
                    {
                        title: "",
                        email: "david.e@creativedesign.com"
                    }
                ],
                vcard_note: t('qrc_io.vcard.summary'),
                vcard_company: t('qrc_io.vcard.company'),
                vcard_social_label: [],
                vcard_social_value: [],
                images: "/images/qci/vcard_avatar.jpg",
                offer_street: t('qrc_io.vcard.location_text'),
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                vcard_add_contact_at_top: 'falseprev',
                street_number: true
            },
            business:{
                contactMobiles: [
                    {
                        title: "",
                        number: "(123) 555-1000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "lori@holidaytoyshop.com"
                    }
                ],
                contactWebsite:[
                    {
                        title:'',
                        website:'www.holidaytoyshop.com'
                    }
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.google'),
                        url: "/images/social/google-transparent.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin-full.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'TikTok',
                        url: "/images/ListOfLinks/tiktok.png"
                    }
                ],
                aboutCompany: t('qrc_io.business.about_company_text'),
                weekDays: {
                    Monday: [
                        {
                            "from": "10:00",
                            "to": "16:00"
                        },
                    ],
                    Tuesday: [
                        {
                            "from": "09:00",
                            "to": "17:00"
                        }
                    ],
                    Wednesday: [
                        {
                            "from": "09:00",
                            "to": "17:00"
                        }
                    ],
                    Thursday: [
                        {
                            "from": "09:00",
                            "to": "17:00"
                        }
                    ],
                    Friday: [
                        {
                            "from": "10:00",
                            "to": "21:00"
                        }
                    ],
                    Saturday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                },
                primaryColor: "#8E413B",
                SecondaryColor: "#D98902",
                companyLogo: "/images/qci/business.webp",
                company: t('qrc_io.business.company'),
                companyTitle: 'Holiday Toy Shop',
                companySubtitle: t('qrc_io.business.description'),
                screen: false,
                contactName: t('qrc_io.business.name_text'),
                businessButtons: t('qrc_io.business.button'),
                businessButtonUrls: "#",
                businessButtonsCreated: "0",
                cardContainer: false,
                ship_address: "",
                offer_street: '3274 Doe Meadow Drive Annapolis Junction, MD 20701',
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                    // "ficon12",
                    // "ficon13",
                    // "ficon14",
                ],
                street_number: true
            },
            images:{
                primaryColor: "#007964",
                image_title: t('qrc_io.images.headerTitle'),
                image_description: t('qrc_io.images.headerDescription'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                website: "www.besttravelphotos.net",
                images: [
                    "/images/qci/image1.webp",
                    "/images/qci/image2.webp",
                ],
                buttons: [
                    {
                        text: t('images.viewMoreButton'),
                        url: "#"
                    }
                ],
                horizontal: true
            },
            video:{
                videos: [],
                direct_video: false,
                Highlight: false,
                Autoplay: false,
                primaryColor: "#C70225",
                companyName:  "Sandra’s Health and Wellness",
                videoTitle: t('qrc_io.video.title'),
                videoDescription: t('qrc_io.video.description'),
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                button_text: t('video.view_more'),
                button_url: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'TikTok',
                        url: "/images/ListOfLinks/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                ],
            },
            app:{
                screen: false,
                SecondaryColor: "#6D40CE",
                primaryColor: "#6D40CE",
                app_title: 'Mindful Comfort',
                app_description: t('qrc_io.app.description'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                app_website: "www.mindfulcomfort.com",
                app_company: t('qrc_io.app.base'),
                google: "#",
                apple: "#",
                amazon: "#",
                images: [],
                companyLogo: "/images/qci/app.png",
            },
            coupon:{
                screen: false,
                newShareIcon: true,
                ship_address: "",
                company:t('qrc_io.coupon.company'),
                title: t('qrc_io.coupon.salesBadge'),
                description: t('qrc_io.coupon.offerDescription'),
                salesBadge: t('coupon.salesBadge'),
                buttonToSeeCode: t('coupon.offerButton'),
                couponCode: "25%%20OFF",
                validTillDate: "",
                terms: [t('coupon.termsParagraph')],
                buttonText: t('coupon.webButton'),
                buttonUrl: "#",
                primaryColor: "#E17D3F",
                SecondaryColor: "#EDED4F",
                companyLogo: "/images/qci/coupon.webp",
                offerImage: "https://t3.ftcdn.net/jpg/02/55/97/94/360_F_255979498_vewTRAL5en9T0VBNQlaDBoXHlCvJzpDl.jpg",
                offer_street: "",
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                street_number: false,
                flip: false,
                barCodeTgl: true,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro"
            },
            mp3:{
                screen: false,
                addDownloadOption: "",
                button_url: "",
                button_text: t('qrc_io.mp3.viewMoreButton'),
                primaryColor: "#0F5B72",
                SecondaryColor: "#0F5B72",
                mp3_title: 'Cruising Beats',
                mp3_description: t('qrc_io.mp3.songDescription'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                mp3_website: "www.thestorms.com",
                mmp3: [
                    "/empty.mp3"
                ],
                images: [],
                image: "/images/qci/mp3.webp",
                button_created: "0",
                socialLinks: [ 
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Spotify",
                        url: "/images/social/spotify.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Soundcloud",
                        url: "/images/social/soundcloud.png"
                    }
                ],
                socialLinksTitle: "Find me on"
            },
            event:{
                screen: false,
                primaryColor: "#07B8B8",
                title: t('qrc_io.event.title'),
                description: t('qrc_io.event.description'),
                image: "/images/qci/event.webp",
                buttonText: t('qrc_io.event.view_more_btn'),
                buttonUrl: "#",
                event_startDate: "2024-02-08",
                event_startTime: t('qrc_io.event.start_time'),
                event_endDate: "2024-02-09",
                event_endTime: t('qrc_io.event.end_time'),
                event_time_zone: "Europe/London",
                event_preview: true,
                ship_address: t('qrc_io.event.address'),
                aboutEvent: t('qrc_io.event.about_description'),
                offer_street: "Main Street",
                offer_number: "2323",
                offer_postalcode: "14850",
                offer_city: "Ithaca",
                offer_state: "NY",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                offer_street_number: true,
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                    // "ficon12",
                    // "ficon13",
                    // "ficon14",
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "(123) 555-4000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "corina@nyhrroundtable.com"
                    }
                ],
                contactWebsite: [
                    {
                        title: "",
                        website: "www.nyhrroundtable.com"
                    },
                ],
                contactName: t('qrc_io.event.contact_name'),
                websites: [
                    {
                        title: "Website",
                        website: "www.nyhrroundtable.com"
                    },
                ],
                
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            facebook:{
                screen: false,
                cover: "/images/qci/fb_cover.webp",
                profileImg: "/images/qci/fb_pic.webp",
                title: t('qrc_io.facebook.title'),
                description: t('qrc_io.facebook.description'),
                pageUrl: "#",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                hide_like:false,
                page_likes:'665k'
            },
            social:{
                screen: false,
                primaryColor: "#DE6C7B",
                images: [
                    "/images/qci/v2/socialMedia/1.webp",
                    "/images/qci/socialMedia/2.webp",
                    "/images/qci/socialMedia/3.webp",
                ],
                title: "Sarah Ann Peters",
                description: t('social.description'),
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "YouTube",
                        url: "/images/social/youtube.png"
                    },
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                horizontal: false
            },
            email:{
                screen: false,
                colors: {
                    primary: "#B5D8EC",
                    secondary: "#FFF",
                },
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                basic_information: {
                    image: "/images/qci/email-bg.jpg",
                    title: t('qrc_io.email.title'),
                    description: t('qrc_io.email.description'),
                },
                email_templates: [
                    {
                        title: t('qrc_io.email.list_1'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "message",
                    },
                    {
                        title: t('qrc_io.email.list_2'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "multimedia",
                    },
                ],
                contactName: t('qrc_io.email.contact_name'),
                contact_details: {
                    phones: [
                        { label: t('qrc_io.com_contact.contact_phone'), icon: "other", number: "(000) 555-1080" },
                    ],
                    emails: [
                        { label: t('qrc_io.com_contact.contact_email'), email: "info@premiumlaw.com" },
                    ],
                    websites: [
                        { label: t('qrc_io.com_contact.contact_website'), url: "www.premiumlawfirm.com" },
                    ],
                },
            },
            menu:{
                roundedLogo: true,
                sections: [
                    {
                        id: "1",
                        name: t('qrc_io.menu.section_1'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Avocado and Shrimp Salad",
                                image: "/images/qci/menu/avocado-and-shrimp-salad.webp",
                                translated: "Salade d'Avocat et Crevettes",
                                description: "Fresh avocado slices and succulent shrimp on a bed of mixed greens, drizzled with a light lemon vinaigrette.",
                                price: "$9",
                                allergens: [
                                    "crustaceans",
                                    "mustard",
                                ]
                            }
                        ]
                    },
                    {
                        id: "8",
                        name: t('qrc_io.menu.section_2'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Herb-Crusted Salmon",
                                image: "/images/qci/menu/herb-crusted-salmon.webp",
                                translated: "Saumon en Croûte d'Herbes",
                                description: "Oven-baked salmon fillet with a crispy herb crust, served with garlic mashed potatoes and steamed asparagus.",
                                price: "$27",
                                allergens: [
                                    "fish",
                                    "fruits"
                                ]
                            }
                        ]
                    },
                    {
                        id: "78",
                        name: t('qrc_io.menu.section_3'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Sparkling Citrus Cooler",
                                image: "/images/qci/menu/sparkling-citrus-coolerwebp.webp",
                                translated: "Rafraîchisseur d'Agrumes Pétillant",
                                description: "A refreshing blend of sparkling water, freshly squeezed orange and lemon juice, with a hint of mint.",
                                price: "$7",
                                allergens: [
                                    "sulfur",
                                ]
                            }
                        ]
                    },
                    {
                        id: "139",
                        name: t('qrc_io.menu.section_4'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Chocolate Lava Cake",
                                image: "/images/qci/menu/chocolate-lava-cake.webp",
                                translated: "Gâteau Fondant au Chocolat",
                                description: "Warm, gooey chocolate cake with a molten center, served with a scoop of vanilla ice cream.",
                                price: "$11",
                                allergens: [
                                    "milk",
                                    "cereals"
                                ]
                            }
                        ]
                    }
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Uber Eats",
                        url: "/images/social/uber.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Google",
                        url: "/images/social/google-transparent.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "TikTok",
                        url: "/images/social/tiktok2.png"
                    }
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "(123) 555-3000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "alex@alexcuisine.com"
                    }
                ],
                activeId: "",
                contactName: t('qrc_io.menu.contact_name'),
                contactWebsite:[
                    {
                        title:'',
                        website:'www.alexandrecuisine.com'
                    }
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                primaryColor: "#B64836",
                companyLogo: "/images/qci/menu.webp",
                companyTitle: t('qrc_io.menu.contact_name'),
                companyDescription: t('qrc_io.menu.subtitle'),
                screen: false,
                weekDays: {
                    Monday: [
                        {
                            from: "10:00",
                            to: "15:00"
                        },
                        {
                            from: "17:00",
                            to: "23:00"
                        },
                    ],
                    Tuesday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Wednesday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Thursday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Friday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Saturday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                },
                areAllDaysNull: false
            },
            review:{
                screen: false,
                primaryColor: "#D97150",
                type: "both", //public, private or both
                publicReviewType: {
                    image: "/images/oqg/google.svg",
                    title: "Google Rating",
                },
                emailInput: true,
                phoneInput: true,
                title: "North Ferris Wheel",
                image: "/images/qci/review.webp",
                website: "www.beststockphotos.com",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            instagram:{
                username: t('instagram.username'),
                step: 1,
                live: true
            },
            whatsapp:{
                number: "+123 456 789",
                step: 1,
                message: "",
                live: true
            },
            sms:{
                sms_number: "+123 456 7890",
                sms_message: "",
                step: 1,
                live: true
            },
        },
        a:{
            pdf: {
                company: 'Software Experts, Inc.',
                pdftitle: t('qrgen_ai.pdf.title'),
                directly_show_pdf: "",
                primaryColor: "#5265C9",
                SecondaryColor: "#5265C9",
                description:  t('qrgen_ai.pdf.description'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                button: t('qrgen_ai.pdf.pdf_btn'),
                pdf: "",
                pdfThumbnail:'',
                website: "www.softwareexpertsinc.com",
                defImg: "/pdf.jpg"
            },
            links:{
                list_title: 'Stephanie Nichols',
                list_description:  t('qrgen_ai.links.about'),
                font_text: "GT Walsheim Pro",
                font_title: "GT Walsheim Pro",
                primaryColor: "#AED0C9",
                companyLogo: "/images/qga/links/stephanie.webp",
                screen: false,
                linkList: [
                    {
                        name: t('qrgen_ai.links.link.About1'),
                        image: "/images/qga/links/stephanie.webp",
                        link: ""
                    },
                    {
                        name:  t('qrgen_ai.links.link.About2'),
                        image: "/images/qga/links/tiktok.png",
                        link: ""
                    },
                    {
                        name:  t('qrgen_ai.links.link.About3'),
                        image: "/images/qga/links/youtube.png",
                        link: ""
                    },
                    {
                        name: t('qrgen_ai.links.link.About4'),
                        image: "/images/qga/links/flight.webp",
                        link: ""
                    },
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Instagram',
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'YouTube',
                        url: "/images/qga/links/youtube.png"
                    },
                    
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'TikTok',
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Facebook',
                        url: "/images/social/facebook.png"
                    },
                ]
            },
            vcard:{
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                vcard_profession: t('qrgen_ai.vcard.profession'),
                primaryColor: "#CD4F41",
                SecondaryColor: "#CD4F41",
                vcard_first_name: "Kyle Thorsen",
                vcard_last_name: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: 'WhatsApp',
                        url: "/images/social/whatsapp.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin-full.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: "X",
                        url: "/images/social/x.png"
                    },
                ],
                vcard_website: [
                    {
                        title: t('vcard.website'),
                        website: "www.webcrafters.com"
                    }
                ],
                vcard_phone: [
                    {
                        label: "",
                        type: "other",
                        number: "(001) 555-1000"
                    }
                ],
                vcard_email: [
                    {
                        title: "",
                        email: "kyle@webcrafters.com"
                    }
                ],
                vcard_note: t('qrgen_ai.vcard.summary'),
                vcard_company: "WebCrafters Studio",
                vcard_social_label: [],
                vcard_social_value: [],
                images: "/images/qga/vcard_avatar.webp",
                offer_street: "82 Liberté Street, 75012 Paris, France",
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                vcard_add_contact_at_top: 'falseprev',
                street_number: true
            },
            business:{
                contactMobiles: [
                    {
                        title: "",
                        number: "(001) 555-1001"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "frances@nwgemstone.com"
                    }
                ],
                contactWebsite:[
                    {
                        title:'',
                        website:'www.nwgemstone.com'
                    }
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin-full.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.google'),
                        url: "/images/social/google-transparent.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'X',
                        url: "/images/social/x.png"
                    }
                ],
                aboutCompany: t('qrgen_ai.business.about_company_text'),
                weekDays: {
                    Monday: [
                        {
                            "from": "10:00",
                            "to": "14:00"
                        },
                        {
                            "from": "17:00",
                            "to": "20:00"
                        },
                    ],
                    Tuesday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Wednesday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Thursday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Friday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Saturday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                },
                primaryColor: "#E49663",
                SecondaryColor: "#E49663",
                companyLogo: "/images/qga/business.webp",
                company: "Explore Our Fine Jewelry!",
                companyTitle: t('qrgen_ai.business.title'),
                companySubtitle: t('qrgen_ai.business.subtitle'),
                screen: false,
                contactName: "Frances Swann",
                businessButtons: t('qrgen_ai.business.button'),
                businessButtonUrls: "#",
                businessButtonsCreated: "0",
                cardContainer: false,
                ship_address: "",
                offer_street: '123 Main Street Seattle, WA 98107',
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                ],
                street_number: true
            },
            images:{
                primaryColor: "#DD6332",
                image_title: t('qrgen_ai.images.headerTitle'),
                image_description: t('qrgen_ai.images.headerDescription'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                website: "www.naturescanvas.com",
                images: [
                    "/images/qga/image1.webp",
                    "/images/qga/image2.webp",
                ],
                buttons: [
                    {
                        text: t('qrgen_ai.images.viewMoreButton'),
                        url: "www.naturescanvas.com"
                    }
                ],
                horizontal: true
            },
            video:{
                videos: [],
                direct_video: false,
                Highlight: false,
                Autoplay: false,
                primaryColor: "#672241",
                companyName: "Kyle’s Rock Band Lessons",
                videoTitle: t('qrgen_ai.video.title'),
                videoDescription: t('qrgen_ai.video.description'),
                video_description: t('qrgen_ai.video.video_description'),
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                button_text: t('qrgen_ai.video.view_more'),
                button_url: "",
                socialLinks: [
                    
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Soundcloud',
                        url: "/images/social/soundcloud.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                ],
            },
            app:{
                screen: false,
                SecondaryColor: "#EE4035",
                primaryColor: "#EE4035",
                app_title: "Vitality Health & Fitness",
                app_description: t('qrgen_ai.app.description'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                app_website: "www.vitalityapp.com",
                app_company: t('qrgen_ai.app.base'),
                google: "#",
                apple: "#",
                amazon: "#",
                images: [],
                companyLogo: "/images/qga/app.webp",
            },
            coupon:{
                screen: false,
                newShareIcon: true,
                ship_address: "",
                company: t('qrgen_ai.coupon.company'),
                title: t('qrgen_ai.coupon.salesBadge'),
                description: t('qrgen_ai.coupon.offerDescription'),
                salesBadge: t('qrgen_ai.coupon.salesBadge'),
                buttonToSeeCode: t('qrgen_ai.coupon.offerButton'),
                couponCode: "20%%20OFF",
                validTillDate: "",
                terms: [t('coupon.termsParagraph')],
                buttonText: t('coupon.webButton'),
                buttonUrl: "#",
                primaryColor: "#3D6732",
                SecondaryColor: "#ECEC4F",
                ThirdColor: "#000000",
                companyLogo: "/images/qga/coupon.webp",
                offerImage: "https://t3.ftcdn.net/jpg/02/55/97/94/360_F_255979498_vewTRAL5en9T0VBNQlaDBoXHlCvJzpDl.jpg",
                offer_street: "",
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                street_number: false,
                flip: false,
                barCodeTgl: true,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro"
            },
            mp3:{
                screen: false,
                addDownloadOption: "",
                button_url: "",
                button_text: t('qrgen_ai.mp3.playlist_btn'),
                primaryColor: "#EACD94",
                SecondaryColor: "#D7B166",
                mp3_title: t('qrgen_ai.mp3.songTitle'),
                mp3_description: t('qrgen_ai.mp3.songDescription'),
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                mp3_website: "www.jamieabernathy.com",
                mmp3: [
                    "/empty.mp3"
                ],
                images: [],
                image: "/images/qga/mp3.webp",
                button_created: "0",
                socialLinks: [ 
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "YouTube",
                        url: "/images/qci/links/youtube.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Apple Music",
                        url: "/images/social/apple-music.png"
                    },
                    
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Spotify",
                        url: "/images/social/spotify.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                ],
                socialLinksTitle: "Find me on"
            },
            event:{
                screen: false,
                primaryColor: "#00296B",
                title: t('event.title'),
                description: t('event.description'),
                image: "/images/images/new/event.webp",
                buttonText: t('event.view_more_btn'),
                buttonUrl: "#",
                event_startDate: "2024-02-08",
                event_startTime: t('event.start_time'),
                event_endDate: "2024-02-09",
                event_endTime: t('event.end_time'),
                event_time_zone: "Europe/London",
                event_preview: true,
                aboutEvent: t('event.about_description'),
                offer_street: "Gower Street",
                offer_number: "49",
                offer_postalcode: "",
                offer_city: "London",
                ship_address:  t('event.address'),
                offer_state: "WC1F 2FA",
                offer_country: "United Kingdom",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                offer_street_number: true,
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                    // "ficon12",
                    // "ficon13",
                    // "ficon14",
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "555-100-1000"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "info@quantech.com"
                    }
                ],
                contactWebsite: [
                    {
                        title: "",
                        website: "www.quantech.com"
                    },
                ],
                contactName: t('event.contact_name'),
                websites: [
                    {
                        title: "Website",
                        website: "www.quantech.com"
                    },
                ],
                
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            facebook:{
                screen: false,
                cover: "/images/qga/fb_cover.webp",
                profileImg: "/images/qga/fb_pic.webp",
                title: 'Fashion Inspiration',
                description: 'Want to get great ideas for your next outfit? The Fashion Inspiration Facebook Group has plenty of tips and tricks to help you find hot looks for every occasion!',
                pageUrl: "#",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                hide_like:false,
                page_likes:'665k'
            },
            social:{
                screen: false,
                primaryColor: "#01817D",
                images: [
                    "/images/qga/socialMedia/3.webp",
                    "/images/qga/socialMedia/2.webp",
                    "/images/qga/socialMedia/1.webp",
                ],
                title: "Rachel Louise Mendes",
                description: "Hello! I’m Rachel Louise Mendes. Let’s connect on social media using the links below! I can’t wait to share my latest content with you.",
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "X",
                        url: "/images/social/x.png"
                    },
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                horizontal: false
            },
            email:{
                screen: false,
                colors: {
                    primary: "#8966A6",
                    secondary: "#000",
                },
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                basic_information: {
                    image: "/images/images/new/email-bg.png",
                    title: t('email.title'),
                    description: t('email.description'),
                },
                email_templates: [
                    {
                        title: t('email.list_1'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "message",
                    },
                    {
                        title: t('email.list_2'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "multimedia",
                    },
                ],
                contactName: t('email.contact_name'),
                contact_details: {
                    phones: [
                        { label: t('com_contact.contact_phone'), icon: "other", number: "555-100-1000" },
                    ],
                    emails: [
                        { label: t('com_contact.contact_email'), email: "info@greenlife.com" },
                    ],
                    websites: [
                        { label: t('com_contact.contact_website'), url: "www.glarchitect.com" },
                    ],
                },
            },
            menu:{
                roundedLogo: true,
                sections: [
                    {
                        id: "1",
                        name: t('qrgen_ai.menu.section_1'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('qrgen_ai.menu.section_1_product_name'),
                                image: "/images/qga/menu/Grilled-Eggplant-Bruschetta.webp",
                                translated: "Bruschetta de Berenjena a la Parrilla",
                                description: t('qrgen_ai.menu.section_1_product_desc'),
                                price: "$10",
                                allergens: [
                                    "milk",
                                ]
                            }
                        ]
                    },
                    {
                        id: "8",
                        name: t('qrgen_ai.menu.section_2'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('qrgen_ai.menu.section_2_product_name'),
                                image: "/images/qga/menu/Tropical-Mango-Smoothie.webp",
                                translated: "Batido Tropical de Mango",
                                description: t('qrgen_ai.menu.section_2_product_desc'),
                                price: "$6",
                                allergens: [
                                    "sulfur",
                                    "milk",
                                    "soy"
                                ]
                            }
                        ]
                    },
                    {
                        id: "78",
                        name: t('qrgen_ai.menu.section_3'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('qrgen_ai.menu.section_3_product_name'),
                                image: "/images/qga/menu/Spicy-Chicken-Enchiladas.webp",
                                translated: "Enchiladas de Pollo Picante",
                                description: t('qrgen_ai.menu.section_3_product_desc'),
                                price: "$18",
                                allergens: [
                                    "peanuts",
                                    "lupins",
                                    "eggs",
                                ]
                            }
                        ]
                    },
                    {
                        id: "139",
                        name: t('qrgen_ai.menu.section_4'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: t('qrgen_ai.menu.section_4_product_name'),
                                image: "/images/qga/menu/Caramel-Flan.webp",
                                translated: "Flan de Caramelo",
                                description: t('qrgen_ai.menu.section_4_product_desc'),
                                price: "$11",
                                allergens: [
                                    "fruits",
                                    "milk",
                                ]
                            }
                        ]
                    }
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Uber Eats",
                        url: "/images/social/uber.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "DoorDash",
                        url: "/images/social/doordash.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Google",
                        url: "/images/social/google-transparent.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "(001) 555-1002"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "stephanie@thecuisine.com"
                    }
                ],
                activeId: "",
                contactName: "Stephanie Smith",
                contactWebsite:[
                    {
                        title:'',
                        website:'www.thecuisine.com'
                    }
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                primaryColor: "#00A2D5",
                companyLogo: "/images/qga/menu.webp",
                companyTitle: "The Cuisine",
                companyDescription: t('qrgen_ai.menu.subtitle'),
                screen: false,
                weekDays: {
                    Monday: [
                        {
                            from: "10:00",
                            to: "15:00"
                        },
                        {
                            from: "17:00",
                            to: "23:00"
                        },
                    ],
                    Tuesday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Wednesday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Thursday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Friday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Saturday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                },
                areAllDaysNull: false
            },
            review:{
                screen: false,
                primaryColor: "#BCA67C",
                type: "both", //public, private or both
                publicReviewType: {
                    image: "/images/oqg/google.svg",
                    title: "Google Rating",
                },
                emailInput: true,
                phoneInput: true,
                title: "Downtown Trolley Tours",
                image: "/images/qga/review.webp",
                website: "www.downtowntrolley.com",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            instagram:{
                username: t('instagram.username'),
                live: true,
                step: 1,
            },
            whatsapp:{
                number: "+123 456 789",
                message: "",
                live: true,
                step: 1,
            },
            sms:{
                sms_number: "+123 456 7890",
                sms_message: "",
                step: 1,
                live: true
            },
        },
        c:{
            pdf: {
                company: 'Best Business Bank, Inc.',
                pdftitle: 'Corporate Checking & Savings',
                directly_show_pdf: "",
                primaryColor: "#EE4035",
                description:  'Download your latest statement and take control of your company’s financial future!',
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                button: t('pdf.button'),
                pdf: "",
                pdfThumbnail:'',
                website: "www.bestbusinessbank.com",
                defImg: "/pdf.jpg"
            },
            links:{
                list_title: 'Carla Rasmussen',
                list_description:  'Follow all of my social media channels for foodies, and join me as I dine around the world!',
                font_text: "GT Walsheim Pro",
                font_title: "GT Walsheim Pro",
                primaryColor: "#F56B4D",
                companyLogo: "/images/qgc/links/carla.png",
                screen: false,
                linkList: [
                    {
                        name: 'Carla’s Favorite Recipes',
                        image: "/images/qgc/links/carla.png",
                        link: ""
                    },
                    {
                        name: "My Cooking Recipe",
                        image: "/images/qgc/links/cooking.png",
                        link: ""
                    },
                    {
                        name: "Carla’s TikTok Profile",
                        image: "/images/qci/links/tiktok.png",
                        link: ""
                    },
                    {
                        name: "Spain Food Tour",
                        image: "/images/qci/links/youtube.png",
                        link: ""
                    },
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Facebook',
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Instagram',
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Snapchat',
                        url: "/images/social/snapchat.png"
                    },
                    
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin-full.png"
                    },
                    
                ]
            },
            vcard:{
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                vcard_profession: "CEO",
                primaryColor: "#65B8BA",
                vcard_first_name: "James Hall",
                vcard_last_name: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: t('vcard.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: 'Telegram',
                        url: "/images/social/telegram.png"
                    },
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: 'LinkedIn',
                        url: "/images/social/linkedin-full.png"
                    },
                    
                    {
                        name: "",
                        text: t('vcard.social_account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                ],
                vcard_website: [
                    {
                        title: t('vcard.website'),
                        website: "www.hallsoftware.com"
                    }
                ],
                vcard_phone: [
                    {
                        label: "",
                        type: "other",
                        number: "(000) 555-1010"
                    }
                ],
                vcard_email: [
                    {
                        title: "",
                        email: "james@hallsoftware.com"
                    }
                ],
                vcard_note: "I am the founder and owner of Hall of Fame Software Development. Contact us to discover our innovative solutions!",
                vcard_company: "Hall of Fame Software Development",
                vcard_social_label: [],
                vcard_social_value: [],
                images: "/images/qgc/vcard_avatar.webp",
                offer_street: "4387 Main St San Antonio, TX 78212",
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                vcard_add_contact_at_top: 'falseprev',
                street_number: true
            },
            business:{
                contactMobiles: [
                    {
                        title: "",
                        number: "(000) 555-1020"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "carl@monamicoffee.com"
                    }
                ],
                contactWebsite:[
                    {
                        title:'',
                        website:'www.monamicoffee.com'
                    }
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Google',
                        url: "/images/social/google.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: 'Uber Eats',
                        url: "/images/social/uber.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "DoorDash",
                        url: "/images/social/doordash.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.facebook'),
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: "Portfolio designs",
                        icon: "Google Review",
                        url: "/images/social/google-review.png"
                    },
                ],
                aboutCompany: "We slow-roast our espresso beans on-site and bake our delicious pastries fresh daily!",
                weekDays: {
                    Monday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        },
                        {
                            "from": "17:00",
                            "to": "20:00"
                        },
                    ],
                    Tuesday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Wednesday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Thursday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Friday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                    Saturday: [
                        {
                            "from": "10:00",
                            "to": "17:00"
                        }
                    ],
                },
                primaryColor: "#78453E",
                SecondaryColor: "#78453E",
                companyLogo: "/images/qgc/business.webp",
                company: "Try Our Pastries and Coffee!",
                companyTitle: "Mon Ami Coffee ",
                companySubtitle: "We roast our coffee beans and bake our pastries in-house!",
                screen: false,
                contactName: "Carl Thomas",
                businessButtons: "Order Now",
                businessButtonUrls: "#",
                businessButtonsCreated: "0",
                cardContainer: false,
                ship_address: "",
                offer_street: '4230 1st Ave N New Orleans, LA 70115',
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                    // "ficon12",
                    // "ficon13",
                    // "ficon14",
                ],
                street_number: true
            },
            images:{
                primaryColor: "#E1810B",
                image_title: "Headshot Photography",
                image_description: "Book our photography services today to get the best headshots in the region!",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                screen: false,
                website: "www.photographyusa.com",
                images: [
                    "/images/qgc/image1.webp",
                    "/images/qgc/image2.webp",
                ],
                buttons: [
                    {
                        text: 'View Gallery',
                        url: "#"
                    }
                ],
                horizontal: true
            },
            video:{
                videos: [],
                direct_video: false,
                Highlight: false,
                Autoplay: false,
                primaryColor: "#FF8857",
                companyName: "Sophia's Studio",
                videoTitle: "Art & Design Class",
                videoDescription: "Learn techniques for everything from graphic design to watercolor painting and so much more!",
                screen: false,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                button_text: "Learn More",
                button_url: "",
                socialLinks: [
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Pinterest",
                        url: "/images/social/pinterest.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('links.social.youtube'),
                        url: "/images/social/youtube.svg"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: t('business.instagram'),
                        url: "/images/social/instagram.webp"
                    },
                ],
            },
            app:{
                screen: false,
                SecondaryColor: "#17B961",
                primaryColor: "#17B961",
                app_title: "GreenPlate Fresh Eating",
                app_description: "GreenPlate Fresh Eating is your one-stop shop for tasty recipes and diet plans!",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                app_website: "www.greenplate.com",
                app_company: "Sustainable Eating App",
                google: "#",
                apple: "#",
                amazon: "#",
                images: [],
                companyLogo: "/images/qgc/app.png",
            },
            coupon:{
                screen: false,
                newShareIcon: true,
                ship_address: "",
                company: "Discount Cookware",
                title: "50% OFF",
                description: "Get a generous discount on any pots and pans in our online store, for a limited time only!",
                salesBadge: "50% OFF",
                buttonToSeeCode: "Get Discount",
                couponCode: "20%%20OFF",
                validTillDate: "",
                terms: [t('coupon.termsParagraph')],
                buttonText: t('coupon.webButton'),
                buttonUrl: "#",
                primaryColor: "#FA9794",
                SecondaryColor: "#FA8794",
                ThirdColor: "#000000",
                companyLogo: "/images/qgc/coupon.webp",
                offerImage: "https://t3.ftcdn.net/jpg/02/55/97/94/360_F_255979498_vewTRAL5en9T0VBNQlaDBoXHlCvJzpDl.jpg",
                offer_street: "",
                offer_number: "",
                offer_postalcode: "",
                offer_city: "",
                offer_state: "",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                street_number: false,
                flip: false,
                barCodeTgl: true,
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro"
            },
            mp3:{
                screen: false,
                addDownloadOption: "",
                button_url: "",
                button_text: "Listen Now!",
                primaryColor: "#680369",
                SecondaryColor: "#680369",
                mp3_title: "The Daily Grind",
                mp3_description: "Kathy Bartlett",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                mp3_website: "www.kathybartlett.com",
                mmp3: [
                    "/empty.mp3"
                ],
                images: [],
                image: "/images/qgc/mp3.webp",
                button_created: "0",
                socialLinks: [ 
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Soundcloud",
                        url: "/images/social/soundcloud.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Spotify",
                        url: "/images/social/spotify.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "Apple Music",
                        url: "/images/social/apple-music.png"
                    },
                    {
                        name: "",
                        text: t('links.socialAccType'),
                        icon: "YouTube",
                        url: "/images/qci/links/youtube.png"
                    },
                ],
                socialLinksTitle: "Find me on"
            },
            event:{
                screen: false,
                primaryColor: "#0060CA",
                title: t('qrb.event.title'),
                description: t('qrb.event.description'),
                image: "/images/qgc/event.webp",
                buttonText: t('qrb.event.view_more_btn'),
                buttonUrl: "#",
                event_startDate: "2024-02-08",
                event_startTime: t('qrb.event.start_time'),
                event_endDate: "2024-02-09",
                event_endTime: t('qrb.event.end_time'),
                event_time_zone: "Europe/London",
                event_preview: true,
                ship_address: t('qrb.event.address'),
                aboutEvent: t('qrb.event.about_description'),
                offer_street: "1269 Main St Fargo",
                offer_postalcode: "58102",
                offer_city: "",
                offer_state: "ND",
                offer_country: "",
                offer_url1: "#",
                latitude: "",
                longitude: "",
                offer_street_number: true,
                ficons: [
                    "ficon",
                    "ficon1",
                    "ficon2",
                    "ficon3",
                    "ficon4",
                    "ficon5",
                    "ficon6",
                    "ficon7",
                    "ficon8",
                    "ficon9",
                    "ficon10",
                    "ficon11",
                    // "ficon12",
                    // "ficon13",
                    // "ficon14",
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "(000) 555-1070"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "kimberly@midwestcyber.com"
                    }
                ],
                contactWebsite: [
                    {
                        title: "",
                        website: "www.midwestcybersummit.com"
                    },
                ],
                contactName: t('qrb.event.contact_name'),
                websites: [
                    {
                        title: "Website",
                        website: "www.midwestcybersummit.com"
                    },
                ],
                
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            email:{
                screen: false,
                colors: {
                    primary: "#2E836E",
                    secondary: "#FFF",
                },
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                basic_information: {
                    image: "/images/qgc/email-bg.png",
                    title: t('qrb.email.title'),
                    description: t('qrb.email.description'),
                },
                email_templates: [
                    {
                        title: t('qrb.email.list_1'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "message",
                    },
                    {
                        title: t('qrb.email.list_2'),
                        email_address: "#",
                        subject: "",
                        body: "",
                        icon: "multimedia",
                    },
                ],
                contact_details: {
                    contact_name: t('qrb.email.contact_name'),
                    phones: [
                        { label: t('qrb.com_contact.contact_phone'), icon: "other", number: "(001) 555-0404" },
                    ],
                    emails: [
                        { label: t('qrb.com_contact.contact_email'), email: "info@harborviewrealty.com" },
                    ],
                    websites: [
                        { label: t('qrb.com_contact.contact_website'), url: "harborviewrealty.com" },
                    ],
                },
            },
            review:{
                screen: false,
                primaryColor: "#14B4DE",
                type: "both", //public, private or both
                publicReviewType: {
                    image: "/images/oqg/google.svg",
                    title: "Google Rating",
                },
                emailInput: true,
                phoneInput: true,
                title: "Venice Beach Snacks",
                image: "/images/qgc/review.webp",
                website: "www.venicesnacks.com",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            social:{
                screen: false,
                primaryColor: "#8A384C",
                images: [
                    "/images/qgc/socialMedia/1.webp",
                    "/images/oqg/social media/2.webp",
                    "/images/oqg/social media/3.webp",
                ],
                title: "Sally Flores",
                description: "I’m Sally — welcome to my social media hub! Click the links below to connect and interact with me on all of my channels!",
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "TikTok",
                        url: "/images/social/tiktok.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Instagram",
                        url: "/images/social/instagram.webp"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Snapchat",
                        url: "/images/social/snapchat.png"
                    },
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                horizontal: false
            },
            facebook:{
                screen: false,
                cover: "/images/qgc/fb_cover.webp",
                profileImg: "/images/oqg/fb_pic.webp",
                title: 'Influencers & Motivators',
                description: 'Learn from social media’s most inspiring influencers! The Influencers & Motivators Facebook group includes helpful tips, tricks of the trade, and a great community!',
                pageUrl: "#",
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
            },
            sms:{
                sms_number: "+123 456 7890",
                sms_message: "",
                primaryColor: "#147EFB",
                live: true
            },
            menu:{
                roundedLogo: true,
                sections: [
                    {
                        id: "1",
                        name: "Appetizers",
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Caprese Skewers",
                                image: "/images/qgc/menu/caprese-skewers.webp",
                                translated: "Spiedini Caprese",
                                description: "Skewers of cherry tomatoes, fresh mozzarella, and basil leaves, drizzled with balsamic reduction.",
                                price: "$7",
                                allergens: [
                                    "soy",
                                ]
                            }
                        ]
                    },
                    {
                        id: "8",
                        name: "Drinks",
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Lemon Basil Iced Tea",
                                image: "/images/qgc/menu/lemon-basil-iced-tea.webp",
                                translated: "Tè Freddo al Limone e Basilico",
                                description: "Refreshing iced tea infused with fresh lemon juice and aromatic basil leaves.",
                                price: "$6",
                                allergens: [
                                    "cereals",
                                ]
                            }
                        ]
                    },
                    {
                        id: "78",
                        name: "Main Courses",
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Fish Piccata",
                                image: "/images/qgc/menu/fish-piccata.webp",
                                translated: "Pesce Piccata",
                                description: "Tender fish fillets lightly coated in flour and pan-seared, then served with a tangy lemon-butter caper sauce. Accompanied by a side of roasted vegetables.",
                                price: "$26",
                                allergens: [
                                    "fish",
                                    "molluscs",
                                    "sesame",
                                ]
                            }
                        ]
                    },
                    {
                        id: "139",
                        name: t('qrc_io.menu.section_4'),
                        description: "",
                        products: [
                            {
                                id: "1",
                                name: "Tiramisu",
                                image: "/images/qgc/menu/tiramisu.webp",
                                translated: "Tiramisù",
                                description: "Italian dessert with layers of coffee-soaked ladyfingers, mascarpone cheese, and cocoa powder.",
                                price: "$9",
                                allergens: [
                                    "milk",
                                    "eggs",
                                    "peanuts",
                                ]
                            }
                        ]
                    }
                ],
                socialLinks: [
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Google",
                        url: "/images/social/google-transparent.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "DoorDash",
                        url: "/images/social/doordash.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Uber Eats",
                        url: "/images/social/uber.png"
                    },
                    {
                        name: "",
                        text: t('social.account'),
                        icon: "Facebook",
                        url: "/images/social/facebook.png"
                    },
                    
                ],
                contactMobiles: [
                    {
                        title: "",
                        number: "(000) 555-1040"
                    }
                ],
                contactEmails: [
                    {
                        title: "",
                        email: "Carl@chefsplace.com"
                    }
                ],
                activeId: "",
                contactName: "Carl Rossi",
                contactWebsite:[
                    {
                        title:'',
                        website:'www.chefsplace.com'
                    }
                ],
                font_title: "GT Walsheim Pro",
                font_text: "GT Walsheim Pro",
                primaryColor: "#1CA0EB",
                companyLogo: "/images/qgc/menu.png",
                companyTitle: "Chef’s Place",
                companyDescription: "Italy’s Best Cuisine!",
                screen: false,
                weekDays: {
                    Monday: [
                        {
                            from: "10:00",
                            to: "14:00"
                        },
                        {
                            from: "17:00",
                            to: "23:00"
                        },
                    ],
                    Tuesday: [
                        {
                            from: "10:00",
                            to: "20:00"
                        }
                    ],
                    Wednesday: [
                        {
                            from: "11:00",
                            to: "19:00"
                        }
                    ],
                    Thursday: [
                        {
                            from: "11:00",
                            to: "19:00"
                        }
                    ],
                    Friday: [
                        {
                            from: "11:00",
                            to: "19:00"
                        }
                    ],
                    Saturday: [
                        {
                            from: "11:00",
                            to: "19:00"
                        }
                    ],
                },
                areAllDaysNull: false
            },
            instagram:{
                username: t('instagram.username'),
                live: true
            },
            whatsapp:{
                number: "+123 456 789",
                message: "",
                live: true
            },
        },
    }
}
